/* eslint-disable @typescript-eslint/no-shadow */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslator } from '@jutro/locale';
import StructureTypeUtil from '../../../util/StructureTypeUtil';
import metadata from './DwellingDetails.metadata.json5';
import styles from './DwellingDetails.module.scss'
import messages from './DwellingDetails.messages.js'

function DwellingDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { yourHomeVM, homeownersVM,
        updateSubmissionVM, findInvalidComponent, showErrors, onValidate, isEitherChangeOrRenewal } = props;
    const [dwellingVM, setDwellingVM] = useState(yourHomeVM);
    const [structDescVisible, setStructDescVisible] = useState(false);
    const [dwellingUsedVisible, setDwellingUsedVisible] = useState(false);
    const [nameOfComplexVisible, setNameOfComplexVisible] = useState(false);
    const [unitVisible, setUnitVisible] = useState(false);
    const [buildingVisible, setBuildingVisible] = useState(false);
    const [farmOrRanchVisible, setFarmOrRanchVisible] = useState(true);
    const [antSatDishVisible, setAntSatDishVisible] = useState(false);
    const [heightVisible, setHeightVisible] = useState(false);
    const [structureCoveredVisible, setStructureCoveredVisible] = useState(false);
    const [unitRequired, setUnitRequired] = useState(false);
    const [structureTypeVisble, setStructuretypeVisble] = useState(false);
    const [qualifyTextVisble, setQualifyTextVisble] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const DWELLING_COMPONENT = 'DwellingDetails';
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(DWELLING_COMPONENT);

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, DWELLING_COMPONENT);
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, DWELLING_COMPONENT);
    }, [findInvalidComponent, isComponentValid])
    
    
    // eslint-disable-next-line camelcase
    const setAdditionalValues_TWIA = useCallback((dwellingVM) => {

        const policyTypeCode = homeownersVM.policyType_TWIA.value.code;

        StructureTypeUtil.structureTypeDetail(dwellingVM, homeownersVM, policyTypeCode, viewModelService);

        const structureTypeValue = _.get(dwellingVM, 'structureType_TWIA.value.code');

        setStructDescVisible(['DwellingOutBuild', 'Deck', 'MiscStructure'].includes(structureTypeValue));
        setDwellingUsedVisible(['1Family', '2Family', 'IndividuallyTH', 'PublicHousing', 'RorBHouse', 'Dwelling', 'AptBuilding', 'ComBuilding', 'Condo'].includes(structureTypeValue));
        setAntSatDishVisible(['AntennaDish'].includes(structureTypeValue));
        setUnitRequired(['RorBHouse', 'AptBuilding', 'Condo'].includes(structureTypeValue));
        setBuildingVisible(['ComBuilding', 'AptBuilding', 'Condo'].includes(structureTypeValue));
        setNameOfComplexVisible(['AptBuilding', 'Condo'].includes(structureTypeValue));
        setUnitVisible(['AptBuilding', 'RorBHouse', 'ComBuilding', 'Condo'].includes(structureTypeValue));
        setHeightVisible(['Deck'].includes(structureTypeValue));
        setStructureCoveredVisible(['Deck'].includes(structureTypeValue));
        setStructuretypeVisble(!(structureTypeValue === 'Condo' || structureTypeValue === 'MHWithPPOnly' || structureTypeValue === 'MHWithPpOpt')); // DE15611- Changes done for structureType visibility(MH)
        setQualifyTextVisble(['PublicHousing'].includes(structureTypeValue));
        setDwellingVM(dwellingVM);
        // updateSubmissionVM(dwellingVM); // DE15663
    }, [homeownersVM, viewModelService])

    const qualifyText = () => (
        <div>
            <h3>{translator(messages.qualifyTextTitle)}</h3>
            <ol>
                <li>
                    {translator(messages.dewellingFirstMessage)}
                </li>
                <li>
                    {translator(messages.dewellingSecondMessage)}
                </li>
                <li>
                    {translator(messages.dewellingThirdMessage)}
                </li>
                <li>
                    {translator(messages.dewellingFourthMessage)}
                </li>
            </ol>
        </div>
    )

    useEffect(() => {
        setAdditionalValues_TWIA(dwellingVM);
    }, [dwellingVM, setAdditionalValues_TWIA])


    const writeValue = useCallback(
        (value, path) => {
            _.set(dwellingVM, path, value);
            setDwellingVM(dwellingVM);
            updateSubmissionVM(dwellingVM);
        }, [dwellingVM, updateSubmissionVM]
    );

    const overrideProps = {
        '@field': {
            // apply to all fields
            // showOptional: true,
            
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        structureDesc: {
            visible: structDescVisible,
            readOnly: isEitherChangeOrRenewal
        },
        dwellingUsed: {
            visible: dwellingUsedVisible
        },
        antennaSatelliteDish: {
            visible: antSatDishVisible
        },
        height: {
            visible: heightVisible
        },
        structureCovered: {
            visible: structureCoveredVisible
        },
        nameOfComplex: {
            visible: nameOfComplexVisible
        },
        unit: {
            visible: unitVisible,
            required: unitRequired,
            showRequired: unitRequired,
            readOnly: isEitherChangeOrRenewal
        },
        building: {
            visible: buildingVisible,
            readOnly: isEitherChangeOrRenewal
        },
        farmOrRanch: {
            // DE15505
            visible: ['ComBuilding', 'Dwelling', '1Family', '2Family', 'IndividuallyTH', 'PublicHousing', 'DwellingOutBuild', 'AntennaDish', 'Fence'
                , 'Boathouse', 'Deck', 'Greenhouse', 'SwimmingPool', 'MiscStructure'].includes(_.get(dwellingVM, 'structureType_TWIA.value.code'))
        },
        structureType: {
            visible: structureTypeVisble,
        },
        qualifyText: {
            content: qualifyText(),
            visible: qualifyTextVisble
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {},
        resolveCallbackMap: {

        },
    };

    return (

        <ViewModelForm
            uiProps={metadata.pageContent}
            model={dwellingVM}
            overrideProps={overrideProps}
            onValueChange={writeValue}
            // onModelChange={updateWizardData}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />

    );
}

DwellingDetails.propTypes = wizardProps;
export default DwellingDetails;
